export const sessionStorage: Storage | null =
  typeof window != "undefined" && window.sessionStorage
    ? window.sessionStorage
    : null;
